import * as React from "react";
import { Wrapper } from "../";
import { Link } from "react-router-dom";
import {
  ArrowsPointingOutIcon,
  BanknotesIcon,
  BuildingOfficeIcon,
  BuildingStorefrontIcon,
  Square3Stack3DIcon,
} from "@heroicons/react/24/outline";
import { detailUrl as realEstateDetailUrl } from "../../../store/realEstates";
import { toMoneyString } from "../../utils/stringUtils";
import {
  useIndustrialPremises,
  detailUrl,
} from "../../../store/industrialPremises";

export default function SmallIndustrialPremisesSummary({ id, className }) {
  const [indp, indpLoading] = useIndustrialPremises(id);

  if (!id) return null;

  return (
    <Wrapper className={className}>
      <div className="flex">
        <div className="mr-3 shrink-0">
          <BuildingStorefrontIcon width={32} className="text-slate-500" />
        </div>
        <div>
          <div className="mb-1 text-base font-semibold leading-none text-gray-700 hover:underline">
            <Link to={detailUrl({ id })}>
              {indp ? indp.premises_id : "Laddar..."}
            </Link>
          </div>

          <p className="mb-3 text-sm font-normal">{indp?.category_display}</p>

          <ul className="text-sm font-light">
            <li className="flex items-center mb-1">
              <BuildingOfficeIcon
                width={16}
                className="mr-1 text-slate-500 font-semibold"
              />
              <Link
                to={realEstateDetailUrl({ id: indp?.realestate?.id })}
                className="text-blue-600 hover:underline"
              >
                {indp?.realestate?.str_representation || "-"}
              </Link>
            </li>
            <li className="flex items-center mb-1">
              <ArrowsPointingOutIcon
                width={16}
                className="mr-1 text-slate-500 font-semibold"
              />
              <span>{indp?.area ? `${indp.area}㎡` : "-"}</span>
            </li>
            <li className="flex items-center mb-1">
              <Square3Stack3DIcon
                width={16}
                className="mr-1 text-slate-500 font-semibold"
              />
              <span>
                {indp?.floors?.map(
                  (f, idx) =>
                    `${idx === 0 ? "Våning " : ""}${f}${
                      idx < indp.floors.length - 1 ? ", " : ""
                    }`
                )}
              </span>
            </li>
            <li className="flex items-center mb-1">
              <BanknotesIcon
                width={16}
                className="mr-1 text-slate-500 font-semibold"
              />
              <span>{toMoneyString(indp?.base_rent, true) || "-"}</span>
            </li>
          </ul>
        </div>
      </div>
    </Wrapper>
  );
}
